var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#889EAD",
    d: "M4 18.5v-2h4v-3.1a5.4 5.4 0 0 1-2.187-1.037A4.5 4.5 0 0 1 4.4 10.45a4.85 4.85 0 0 1-3.137-1.637A4.8 4.8 0 0 1 0 5.5v-1q0-.824.588-1.412A1.93 1.93 0 0 1 2 2.5h2v-2h10v2h2q.824 0 1.413.587Q18 3.676 18 4.5v1q0 1.9-1.262 3.313A4.85 4.85 0 0 1 13.6 10.45q-.45 1.15-1.412 1.913A5.4 5.4 0 0 1 10 13.4v3.1h4v2zM4 8.3V4.5H2v1q0 .95.55 1.713Q3.1 7.975 4 8.3m5 3.2q1.25 0 2.125-.875A2.9 2.9 0 0 0 12 8.5v-6H6v6q0 1.25.875 2.125A2.9 2.9 0 0 0 9 11.5m5-3.2q.9-.326 1.45-1.088T16 5.5v-1h-2z"
  })));
};
export default SvgTrophy;